export default __webpack_public_path__ + "static/media/3.a4bd1054.webp";